import { render, staticRenderFns } from "./SupplierTable.vue?vue&type=template&id=f5be9df6&scoped=true"
import script from "./SupplierTable.vue?vue&type=script&lang=js"
export * from "./SupplierTable.vue?vue&type=script&lang=js"
import style0 from "./SupplierTable.vue?vue&type=style&index=0&id=f5be9df6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5be9df6",
  null
  
)

export default component.exports